'use client';

import { useTranslations } from 'next-intl';

import { LogoGermen } from './logo';
import { MobileMenu } from './mobile-menu';

type HeaderProps = {
  view: 'demo' | 'landing';
  goToDemo: () => void;
  goToLanding: () => void;
};

export const Header = ({ view, goToDemo, goToLanding }: HeaderProps) => {
  const t = useTranslations('landing.germen.simulator.header');
  const showNavigation = view === 'landing';

  return (
    <header className="sticky top-0 z-50 w-full bg-white">
      <div className="mx-auto flex max-w-screen-xl grid-cols-3 items-center justify-between px-4 py-5 lg:grid">
        <LogoGermen onClick={goToLanding} />
        {!!showNavigation && (
          <>
            <nav className="hidden justify-self-center lg:block">
              <ul className="flex gap-6">
                <li>
                  <button
                    className="text-sm hover:underline"
                    onClick={goToDemo}
                  >
                    {t('navigation.simulator')}
                  </button>
                </li>
                <li>
                  <a className="text-sm hover:underline" href="#contact">
                    {t('navigation.contact')}
                  </a>
                </li>
              </ul>
            </nav>
            <div className="block lg:hidden">
              <MobileMenu goToDemo={goToDemo} />
            </div>
          </>
        )}
      </div>
    </header>
  );
};
